import { Card, Col, Flex, Row, Typography } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { BluePrimary, Gray5, Gray8 } from '../../../styles';
import MessageInput from './MessageInput';

const { Text } = Typography;

const StyledFlex = styled(Flex)`
  padding-top: 40px;
`;

const LogoCircle = styled.img`
  width: 120px;
  height: 120px;
`;

const WelcomeText = styled(Text)`
  font-size: 24px;

  .highlight {
    color: ${BluePrimary};
    font-weight: 500;
  }
`;

const ExampleText = styled(Text)`
  font-size: 13px;
  color: ${Gray8};
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

const StyledRow = styled(Row)`
  max-width: 800px;
`;

const StyledCard = styled(Card)`
  cursor: pointer;
  height: 100%;
  border: 1px solid ${Gray5};

  &:hover {
    border-color: ${BluePrimary};
    box-shadow: 0 2px 8px rgba(22, 119, 255, 0.1);
    transform: translateY(-2px);
  }
`;

const examplePrompts = [
  'Summarize the key insights, patterns, and implications from this dataset.',
  'Create detailed personas that reflect the view of respondents and their motivations.',
  'Analyze trends by segment and highlight where responses differ meaningfully.',
  'Identify which themes most often appear together and explain the patterns.',
];

function WelcomePage({ inputValue, setInputValue, sendMessage, loading }) {
  return (
    <StyledFlex vertical align="center" gap={24} data-cy="chat-welcome">
      <Flex vertical align="center">
        <LogoCircle src="/fathomer_icon.svg" alt="Fathomer" />
        <WelcomeText>
          What can I help you <span className="highlight">answer?</span>
        </WelcomeText>
      </Flex>
      <MessageInput
        inputValue={inputValue}
        setInputValue={setInputValue}
        sendMessage={sendMessage}
        hasMessages={false}
        loading={loading}
      />
      <StyledRow gutter={[8, 8]}>
        <Col span={24}>
          <ExampleText>Get started with an example below</ExampleText>
        </Col>
        {examplePrompts.map((prompt) => (
          <Col key={prompt} span={12}>
            <StyledCard size="small" data-cy="example-prompt" onClick={() => setInputValue(prompt)}>
              {prompt}
            </StyledCard>
          </Col>
        ))}
      </StyledRow>
    </StyledFlex>
  );
}

WelcomePage.propTypes = {
  inputValue: PropTypes.string.isRequired,
  setInputValue: PropTypes.func.isRequired,
  sendMessage: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default WelcomePage;
